export const APP_LINK = 'link';
export const APP_MANAGER = 'manager';
